import { render, staticRenderFns } from "./AssistantServiceExtras.vue?vue&type=template&id=0a1bf763"
import script from "./AssistantServiceExtras.vue?vue&type=script&lang=js"
export * from "./AssistantServiceExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports